import { Component, inject } from '@angular/core';
import { AdminService } from '@banyan/modules/admin/services/admin.service';

@Component({
  selector: 'app-admin-need-capture-settings',
  templateUrl: './admin-need-capture-settings.component.html',
  styleUrl: './admin-need-capture-settings.component.scss',
})
export class AdminNeedCaptureSettingsComponent{
    adminService = inject(AdminService);
    isIntroEnabled = true;

    onSettingToggle(key: string, value: boolean): void {
        const current = this.adminService.settings();
        this.adminService.settings.update(current => ({
          ...current,
          [key]: value,
        }));
        this.adminService.updateSetting(key, value);
      }
}
